import { environment } from '@environments/environment';

export const getBrandingDomain = (): string => {
  let domain = environment.mobileApp?.isMobileApp ? environment.mobileApp.defaultDomain : `${location.protocol}//${location.hostname}`;

  if (domain === 'http://localhost') {
    domain = 'https://my.dashly-dev.com';
  }

  return domain;
};
